import React from 'react';

interface LoadingSkeletonProps {
  className?: string;
  height?: string;
  width?: string;
  rounded?: boolean;
}

export const LoadingSkeleton: React.FC<LoadingSkeletonProps> = ({
  className = '',
  height = '1rem',
  width = '100%',
  rounded = false,
}) => {
  return (
    <div
      className={`animate-pulse bg-gray-800 ${rounded ? 'rounded-full' : 'rounded'} ${className}`}
      style={{ height, width }}
    />
  );
};

export const CardSkeleton: React.FC = () => {
  return (
    <div className="bg-gray-900 rounded-lg p-4 space-y-3">
      <LoadingSkeleton height="2rem" width="60%" />
      <LoadingSkeleton height="1rem" width="80%" />
      <LoadingSkeleton height="1rem" width="40%" />
    </div>
  );
};

export const TableSkeleton: React.FC<{ rows?: number }> = ({ rows = 5 }) => {
  return (
    <div className="space-y-2">
      {Array.from({ length: rows }).map((_, i) => (
        <div key={i} className="flex gap-2">
          <LoadingSkeleton height="2rem" width="20%" />
          <LoadingSkeleton height="2rem" width="15%" />
          <LoadingSkeleton height="2rem" width="15%" />
          <LoadingSkeleton height="2rem" width="15%" />
          <LoadingSkeleton height="2rem" width="15%" />
          <LoadingSkeleton height="2rem" width="20%" />
        </div>
      ))}
    </div>
  );
}; 